import React, { useContext } from 'react';
import { object, string, array, func } from 'prop-types';
import { LoadingGigCardCarousel } from '@fiverr-private/gig_listings';
import { LazyPersonalizedSectionFetcher as LazySectionFetcher } from '@fiverr-private/personalized_content';
import SharedContext from '../../context';
import { SLIDER_BREAKPOINTS } from './constants';
import './style.scss';

const PERSEUS_NAME = 'collections';

const LazyPersonalizedSectionFetcher = ({
    className,
    sectionName,
    recommendationsParams,
    collections,
    onUpdateCollections,
    pageName,
}) => {
    const { sourceInfo, rollouts } = useContext(SharedContext);

    const collectProps = {
        collections,
        sourceInfo,
        onUpdateCollections,
    };

    const enrichedRecommendationsParams = {
        ...recommendationsParams,
        pageName,
        funnelName: pageName,
    };

    return (
        <div className={className}>
            <LazySectionFetcher
                perseusName={PERSEUS_NAME}
                placeholder={
                    <div className="loading-placeholder">
                        <LoadingGigCardCarousel isInfinite sliderBreakpoints={SLIDER_BREAKPOINTS} />
                    </div>
                }
                appName={sourceInfo.name}
                sectionName={sectionName}
                recommendationsParams={enrichedRecommendationsParams}
                collectProps={collectProps}
                rollouts={rollouts}
                useV5Routes={true}
            />
        </div>
    );
};

LazyPersonalizedSectionFetcher.propTypes = {
    className: string,
    sectionName: string.isRequired,
    recommendationsParams: object,
    collections: array,
    onUpdateCollections: func,
    pageName: string,
};

export default LazyPersonalizedSectionFetcher;
